<template>
    <ul class="mapType">
      <li v-for="item in mapList" :key="item.value"  @click="changeBasemap(item)"   :class="['item', item.class,{actived: activedMap === item.value}]"></li>
    </ul>
  </template>
  <script>
  // import _ from 'lodash'
//   import { map2d, map3d, vedioMap, emptyMap } from '../mapTypes'
//   import { baseMapChange } from '@/views/components/Map/OpenlayersMap/utils/layerControl'
  export default {
    name: 'MapType',
    components: {},
    directives: {},
    filters: {},
    props: [],
    data() {
      return {
        mapList: [
          {
            name: '影像地图',
            class: 'mapType-image',
            value: 'vedioMap',
            layer: 'Imge_DZDT'
          },
          // {
          //   name: '3D地图',
          //   class: 'mapType-3d',
          //   value: map3d
          // },
          {
            name: '电子地图',
            class: 'mapType-normal',
            value: 'map2d',
            layer: 'XZQHLayer'
          }
        ]
      }
    },
    computed: {
      activedMap() {
        //return this.$store.state.onemapApplication.activedMap
      },
      // 路由地址
      routerPath() {
       // return this.$store.state.global.routerPath
      }
    },
    watch: {
    },
    created() { },
    mounted() {
      //初始化底图为二维
      this.onMapChange('map2d')
    },
    methods: {
      onMapChange(map) {
        //this.$store.commit('onemapApplication/setActivedMap', map)
      },
      changeBasemap(item) {
        if (item.value !== this.activedMap) {
          this.onMapChange(item.value)
          if (item.value !== 'map3d') {
           // this.$store.commit('onemapApplication/setMapName', item.layer)
           // baseMapChange.bind(this)(item.layer)
          }
          //显示部分工具面板
          this.setSwipeStore(map3d !== item.value)
        }
      },
      setSwipeStore(boolean) {
        //if (this.routerPath === '/onemapApplication/PlanningDetails') {
        //  return
       // }
       // this.$store.commit('onemapApplication/setIsShowSearch', boolean)
       // this.$store.commit('onemapApplication/setIsShowMapBL', boolean)
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .mapType {
    height: 60px;
    width: 72px;
    position: absolute;
    bottom: 8px;
    right: 10px;
    cursor: pointer;
    .item {
      position: absolute;
      bottom: 0;
      width: 72px;
      height: 100%;
      border: 1px solid rgba(125, 125, 125, 1);
      border-radius: 4px;
      transition: all 0.3s;
    }
    .mapType-empty {
      right: 12px;
      background: url('../assets/image/map/empty-1.png') no-repeat 0% 0%;
      background-size: 100% 100%;
      // z-index: 5;
      &:hover,
      &.actived {
        background: url('../assets/image/map/empty-2.png') no-repeat 0% 0%;
        background-size: 100% 100%;
      }
    }
    .mapType-image {
      right: 8px;
      background: url('../assets/image/map/yxt-1.png') no-repeat 0% 0%;
      background-size: 100% 100%;
      // z-index: 5;
      &:hover,
      &.actived {
        background: url('../assets/image/map/yxt-2.png') no-repeat 0% 0%;
        background-size: 100% 100%;
      }
    }
    
    .mapType-normal {
      right: 0;
      background: url('../assets/image/map/dt-1.png') no-repeat 0% 0%;
      background-size: 100% 100%;
      // z-index: 20;
      &:hover,
      &.actived {
        background: url('../assets/image/map/dt-2.png') no-repeat 0% 0%;
        background-size: 100% 100%;
      }
    }
    &:hover {
      width: 320px;
      .mapType-empty {
        right: 234px;
      }
      .mapType-image {
        right: 96px;
      }
      .mapType-3d {
        right: 78px;
      }
    }
  }
  </style>
  